import { useDispatch } from "react-redux";
import { useCallback, useEffect, useRef, useState } from "react";
import { useApp } from "../../hooks/useApp";
import { setIsOpenBurger, setIsOpenHeader } from "../../redux/app/slice";
import {
  BurgerButton,
  HeaderStyled,
  LangSwitcher,
  LeftContainer,
  Logo,
  Nav,
  NavLinkStyled,
  RightContainer,
} from "./Header.styled";
import { Container } from "../Container/Container";
import clsx from "clsx";
import { useHeader } from "../../hooks/useHeader";
import { useBurger } from "../../hooks/useBurger";
import useLanguage from "../../hooks/useLanguage.js";
import { useLanguageSchema } from "../../hooks/useLanguageSchema.js";
import { Link } from "react-router-dom";
import img from "../../img/logo.png";

export const lang = [
  { code: "en", name: "EN" },
  { code: "ar", name: "AR" },
];

const Header = () => {
  const dispatch = useDispatch();
  const { isBanner } = useHeader();
  const [isScroll, setIsScroll] = useState(false);
  const { isOpen } = useBurger();
  const [language, setLanguage] = useLanguage();

  const {
    header: { nav, request },
  } = useLanguageSchema();

  const { isOpenHeader } = useApp();

  const openBurger = useCallback(() => {
    dispatch(setIsOpenBurger(!isOpen));
  }, [dispatch, isOpen]);

  let lastScrollTop = useRef(0);

  const handleScroll = useCallback(() => {
    let scrollTop = window.scrollY || document.documentElement.scrollTop;
    let tempScroll = scrollTop - lastScrollTop.current;

    let tempUp = -30;
    let tempDown = 10;

    if (tempScroll < 0) {
      // scroll up
      if (!isOpenHeader && tempScroll < tempUp) {
        dispatch(setIsOpenHeader(true));
      }

      if (scrollTop <= 10 && isScroll) {
        setIsScroll(false);
      }
    } else {
      //scroll down
      if (scrollTop >= 80 && !isScroll) {
        setIsScroll(true);
      }

      if (scrollTop >= 100 && isOpenHeader && tempScroll > tempDown) {
        dispatch(setIsOpenHeader(false));
      }
    }

    lastScrollTop.current = scrollTop;
  }, [dispatch, isOpenHeader, isScroll]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  return (
    <HeaderStyled
      className={clsx(
        !isBanner && "not-banner",
        isScroll && "scroll",
        isOpen && "burger-open"
      )}
    >
      <Container>
        <LeftContainer>
          <Logo>
            <div className="logo-text">
              <Link to="/">
                <img
                  className="logo-img"
                  width={120}
                  src={img}
                  alt="Aurabyte Technologies Logo"
                />
              </Link>
            </div>
          </Logo>
          {/* Desktop/Laptop/Tablet nav */}
          <Nav className="desktop-nav">
            {nav.map((link, index) => (
              <NavLinkStyled key={index} to={link.link}>
                {link.title}
              </NavLinkStyled>
            ))}
          </Nav>
        </LeftContainer>
        <RightContainer>
          <Link className="desktop-service styled-button" to="/#contact">
            <p>{request}</p>
          </Link>
          {lang.length > 1 && (
            <LangSwitcher className="desktop-lang">
              {lang.map((item) => (
                <button
                  key={item.code}
                  className={clsx(
                    "lang-btn",
                    language === item.code && "active"
                  )}
                  onClick={() => setLanguage(item.code)}
                >
                  {item.name}
                </button>
              ))}
            </LangSwitcher>
          )}
        </RightContainer>
        <BurgerButton
          type="button"
          onClick={openBurger}
          className={clsx(
            isOpen && "is-open",
            (!isBanner || isScroll || isOpen) && "black"
          )}
        >
          <span></span>
          <span></span>
          <span></span>
        </BurgerButton>
      </Container>
    </HeaderStyled>
  );
};

export default Header;
